import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=a0c5fb46&scoped=true&"
import script from "./changePassword.vue?vue&type=script&lang=js&"
export * from "./changePassword.vue?vue&type=script&lang=js&"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=a0c5fb46&prod&lang=less&scoped=true&"
import style1 from "./changePassword.vue?vue&type=style&index=1&id=a0c5fb46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c5fb46",
  null
  
)

export default component.exports